import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { refreshOrRedirect$ } from './token-refresh.util';

export const teamGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const token = localStorage.getItem('token');
  if (!token) {
    return router.createUrlTree(['/login']);
  }

  let payload: any;
  try {
    payload = JSON.parse(atob(token.split('.')[1]));
  } catch {
    localStorage.removeItem('token');
    return router.createUrlTree(['/login']);
  }

  const checkRole = (p: any): boolean | UrlTree =>
    p.role !== 'team_member' ? router.createUrlTree(['/home']) : true;

  if (payload.exp && Date.now() / 1000 > payload.exp) {
    return refreshOrRedirect$(auth, router).pipe(
      map((result) =>
        result === false || result instanceof UrlTree ? result : checkRole(result),
      ),
    );
  }

  return checkRole(payload);
};
